import API from "../../api/api";
import { authHeaderWithImage } from "../../helpers/authHeader";
const state = () => ({
  offRoad: null,
  loading: false,
});

const mutations = {
  getOffRoadDetail(state, payload) {
    state.offRoad = payload;
  },
  addOffRoad(state, payload) {
    state.offRoad = payload;
  },
  editOffRoad(state, payload) {
    // const index = state.models.findIndex((m) => m.id === payload.id);
    // if (index) {
    state.offRoad = payload;
    // }
  },
  setDetailInput: (state, e) => {
    let offRoad = state.offRoad;
    offRoad[e.target.name] = e.target.value;
    state.offRoad = offRoad;
  },
  isLoading(state, payload) {
    state.loading = payload;
  },
};

const actions = {
  async fetchOffRoadDetail({ commit }, payload) {
    commit("isLoading", true);
    await API.get(`off-road/${payload}`)
      .then(res => {
        commit("getOffRoadDetail", res.data.data);
        commit("isLoading", false);
      })
      .catch(err => {
        console.log("ERROR", err);
        commit("isLoading", false);
      });
  },
  async post({ commit }, payload) {
    await API.post("off-road", payload, {
      headers: authHeaderWithImage(),
    })
      .then(res => {
        commit("addOffRoad", res.data.data);
      })
      .catch(err => {
        console.log("ERROR", err);
      });
  },
  async put({ commit }, payload) {
    await API.put(`off-road/1`, payload, {
      headers: authHeaderWithImage(),
    })
      .then(res => {
        if (res) {
          commit("editOffRoad", res.data.data);
        }
      })
      .catch(err => {
        console.log("ERROR", err);
      });
  },
  updateInput({ commit }, e) {
    commit("setDetailInput", e);
  },
};

const getters = {
  offRoad: state => state.offRoad,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
